import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { WorkflowStep } from 'src/app/models/workflow-step';
import { WorkflowService } from 'src/app/services/workflow.service';
import { EditWorkflowStepDescriptionComponent } from './dialogs/edit-description/edit-description.component';

@Component({
  selector: 'admin-workflow-steps',
  templateUrl: './workflow-steps.component.html',
  styleUrls: ['./workflow-steps.component.scss']
})
export class WorkflowStepsComponent implements OnInit {

  displayedColumns: string[] = ['id', 'nome', 'incarichi', 'actions'];
  dataSource: WorkflowStep[] = [];
  loading = true;
  errorMessage = '';

  constructor(
    private workflowService: WorkflowService,
    private dialog: MatDialog,
    private toast: ToastrService,
  ) { }

  ngOnInit(): void {
    this.loadWorkflowSteps();
  }

  loadWorkflowSteps(): void {
    this.loading = true;
    this.errorMessage = '';

    this.workflowService
      .getWorkflow({}, null, { mode: 'light', scope: 'studio' })
      .pipe(take(1))
      .subscribe({
        next: (steps) => {
          this.dataSource = steps ?? [];
          this.loading = false;
        },
        error: (error) => {
          console.error('Failed to load workflow steps', error);
          this.errorMessage = 'Impossibile caricare i workflow step. Riprova più tardi.';
          this.loading = false;
        }
      });
  }

  trackByStepId(_index: number, step: WorkflowStep): number {
    return step?.id ?? _index;
  }

  getIncarichiCount(step: WorkflowStep): number {
    return step?.incarichi?.length ?? 0;
  }

  editDescription(step: WorkflowStep): void {
    const dialogRef = this.dialog.open(EditWorkflowStepDescriptionComponent, {
      width: '600px',
      data: { step }
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(async (descrizione?: string) => {
      if (descrizione === undefined) {
        return;
      }

      this.loading = true;
      this.errorMessage = '';
      try {
        await this.workflowService.updateWorkflowStep(step.id, { descrizione });
        this.toast.success('Descrizione aggiornata.');
        this.loadWorkflowSteps();
      } catch (error) {
        console.error('Failed to update workflow step description', error);
        this.errorMessage = 'Impossibile aggiornare la descrizione. Riprova più tardi.';
        this.toast.error('Aggiornamento descrizione fallito.', 'Errore');
        this.loading = false;
      }
    });
  }
}
